import { Box, Skeleton, Stack } from "@mui/material";

const PageSkeleton = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "#f6f8fb",
        p: { xs: 2, md: 4 },
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Stack
        spacing={3}
        sx={{
          width: "100%",
          maxWidth: 500,
        }}
      >
        {/* Header */}
        <Skeleton variant="text" width="60%" height={40} />

        {/* Content */}
        <Skeleton variant="rectangular" height={120} sx={{ borderRadius: 2 }} />

        <Skeleton variant="text" width="80%" />
        <Skeleton variant="text" width="40%" />

        {/* Button */}
        <Skeleton
          variant="rectangular"
          height={40}
          sx={{ borderRadius: 2, width: 120 }}
        />
      </Stack>
    </Box>
  );
};

export default PageSkeleton;